/**
 * 使用范围
 * 订单管理->查看
 * */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
export default createStore({
    state: {},
    effects: {
        // desc 订单管理->查看  获取成交信息
        getDealInfo(paramsData) {
            return API.goods.getCustomerServiceByGoodsId(paramsData.goodsId);
        },
    },
    reducers: {},
});
